<script>
import { getScrollTop, getBoundingClientRect } from 'common/js/dom'
const DOM_CLASSNAME = [
  'top-result-banner',
  'person',
  'prod-box',
  'demon-wrap',
  'insurance-clause',
  'card-function-bar',
  'name-explain-wrap',
  'prompt-wrap'
]
export default {
  name: 'SharingScreen',
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {}
  },
  mounted () {
    let elementsTop = this.calculateElementsTop()
    this.$emit('input', elementsTop)

    this.firedNum = 0
    this.recordOldValue = {
      width: 0,
      height: 0
    }
    let MutationObserver =
      window.MutationObserver ||
      window.WebKitMutationObserver ||
      window.MozMutationObserver
    let element = document.querySelector('#app')
    let observer = new MutationObserver(mutationList => {
      let observeIgnore = false
      for (let mutation of mutationList) {
        if (mutation.target.parentNode) {
          observeIgnore = mutation.target.parentNode.className == 'timer'
        }
      }
      if (observeIgnore) return
      elementsTop = this.calculateElementsTop()
      if (!this.checkChange(elementsTop)) return
      this._elementsTop = elementsTop
      this.$emit('input', elementsTop)
    })
    observer.observe(element, {
      subtree: true,
      childList: true,
      attributes: true,
      // characterData: true,
      attributeOldValue: true
    })
    let resizeFn = () => {
      elementsTop = this.calculateElementsTop()
      if (!this.checkChange(elementsTop)) return
      this._elementsTop = elementsTop
      this.$emit('input', elementsTop)
    }
    window.addEventListener('resize', this.resizeFn)
    this.$once('hook:beforeDestroy', () => {
      observer.disconnect()
      observer.takeRecords()
      observer = null
      window.removeEventListener('resize', resizeFn)
      resizeFn = null
    })
  },
  methods: {
    calculateElementsTop () {
      let elementsTop = []
      const scrollTop = getScrollTop()
      DOM_CLASSNAME.forEach(cls => {
        const domAry = document.querySelectorAll(`.${cls}`)
        if (cls !== 'prod-box') {
          domAry[0] &&
            elementsTop.push(
              parseInt(getBoundingClientRect(domAry[0]).top) + scrollTop
            )
          return
        }
        domAry.forEach(dom => {
          const nameSelector = '.prod-name'
          const insSelector = '.ins-box'
          const nameDom = dom.querySelector(nameSelector)
          const insDom = dom.querySelectorAll(insSelector)
          if (nameDom) {
            elementsTop.push(
              parseInt(getBoundingClientRect(nameDom).top) + scrollTop
            )
          }
          insDom.forEach(idom => {
            elementsTop.push(
              parseInt(getBoundingClientRect(idom).top) + scrollTop
            )
            const childSelector = '.description1'
            const childDomAry = idom.querySelectorAll(childSelector)
            childDomAry.forEach(cdom => {
              elementsTop.push(
                parseInt(getBoundingClientRect(cdom).top) + scrollTop
              )
            })
          })
        })
      })
      return elementsTop
    },
    checkChange (list) {
      const { _elementsTop } = this
      if (!_elementsTop || !Array.isArray(_elementsTop)) return true
      const topAry = [..._elementsTop]
      if (topAry.length !== list.length) {
        return true
      } else {
        for (let i = 0; i < topAry.length; i++) {
          if (topAry[i] !== list[i]) {
            return true
          }
        }
        return false
      }
    }
  }
}
</script>
<template>
  <div />
</template>
